import React from 'react';
import HeaderPolicity from '../components/HeaderPolicity';

export default function Support() {
  return (
    <>

      <HeaderPolicity />

      <div className='min-h-screen flex flex-col items-center  bg-gray-100 p-4'>
        <div className='bg-white rounded-lg shadow-lg p-6 max-w-3xl w-full'>
          <h1 className='text-3xl font-bold mb-4'>Suporte</h1>
          <p className='mb-4'>
            Precisa de ajuda com o Fonotherapp? Nosso suporte está disponível para você via email e WhatsApp!
          </p>
          <p className='mb-4'>
            Você pode entrar em contato conosco através do email: <a href='mailto:fonoterapp@gmail.com' className='text-blue-600 hover:underline'>fonoterapp@gmail.com</a>
          </p>
          <p className='mb-4'>
            Ou pelo nosso WhatsApp: <a href='https://wa.me/+557196204608' className='text-blue-600 hover:underline'>Clique aqui para conversar pelo WhatsApp</a>
          </p>
          <p className='mb-4'>
            Estamos aqui para ajudar com qualquer dúvida ou problema que você possa ter. Não hesite em nos contatar!
          </p>
        </div>
      </div>

    </>

  );
}
